import React from 'react'; 
import './Header.css'; // Ensure you have proper CSS for styling
import Logo from '../Assets/RubyandRed_Logo_V1.png'; // Ensure you have the correct path to your logo image

const Header = () => {
  const bannerUrl = "https://cdn.builder.io/api/v1/image/assets/TEMP/c4d7a9442a099b06d6ad7c5af8d0c2c0f577895880452e3beb5aa2e0038f2f0b?apiKey=92fd0075832b4e0e9d83ec4c344782dc&";

  return (
    <header className="header">
      <div
        className="banner"
        style={{
          backgroundImage: `url(${bannerUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          backgroundAttachment: 'fixed',
        }}
      >
        <img src={Logo} alt="Logo" className="header-logo" />
        <h1 className="header-title">Your Page Title Here</h1>
      </div>
    </header>
  );
};

export default Header;
